import './App.css';
import { Box } from '@mui/material';
import { DesktopTerminalComponent } from './DesktopTerminalComponent';
import { Window } from './Window';
import aboutBody from './aboutText.txt';
import projectsLinks from './projectsLinks.txt';
import projectsText from './projectsText.txt';
import socialLinks from './socialLinks.txt';
import services from './services.txt'
import experience from './experience.txt'
import { MobileTerminalComponent } from './MobileTerminalComponent';

function App() {
 	return (
		<>
			<div className="desktop_container" overflow={'hidden'}>
				<div display="flex" style={{background:'#ffffff'}}>
					<Box display="flex"  justifyContent={'space-between'} paddingX="1vw" paddingY='1vh'>
						<Box display="flex" flexDirection={'column'} justifyContent={'space-around'} style={{maxWidth:'100vw'}}>
							<div style={{background:'#ffffff'}}>
								<Window width={80} name={'about.txt'} logo={""} links={""} body={aboutBody} projects={""}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={80} name={'experience.txt'} logo={""} links={""} body={""} projects={experience}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={80} name={'services.txt'} logo={""} links={""} body={""} projects={services}></Window>
							</div>
						</Box>
						<Box display='flex' flexDirection={'column'} justifyContent={'space-between'}>
							<DesktopTerminalComponent style={{maxHeight:'80vh'}}/>
							<Box display='flex' justifyContent={'center'} style={{fontFamily:'monospace'}}> Copyright © Madeline Hatfield 2024</Box>
						</Box>
						<Box display="flex" flexDirection={'column'}  justifyContent={'space-around'}>
							<div style={{background:'#ffffff'}}>
								<Window width={75} name={'projects.txt'} logo={""} links={projectsLinks} body={""} projects={projectsText}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={75} name={'contact-me.txt'} logo={""} links={socialLinks} body={""} projects={""}></Window>
							</div>
						</Box>
					</Box>
				</div>
			</div>
			<div className="mobile_container">
				<div display="flex" justifyContent={'center'} style={{background:'#ffffff'}} overflow={'hidden'}>
					<Box display='flex' overflow={'hidden'} flexDirection={'column'} justifyContent={'space-between'}>
						<MobileTerminalComponent style={{maxHeight:'80vh'}}/>
					</Box>
					<Box display="flex" flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
						<Box display="flex" flexDirection={'column'} justifyContent={'center'}  style={{maxWidth:'100vw'}}>
							<div style={{background:'#ffffff'}}>
								<Window width={53} name={'about.txt'} logo={""} links={""} body={aboutBody} projects={""}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={53} name={'experience.txt'} logo={""} links={""} body={""} projects={experience}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={53} name={'services.txt'} logo={""} links={""} body={""} projects={services}></Window>
							</div>
						</Box>
						<Box display="flex" flexDirection={'column'}  justifyContent={'space-around'}>
							<div style={{background:'#ffffff'}}>
								<Window width={53} name={'projects.txt'} logo={""} links={projectsLinks} body={""} projects={projectsText}></Window>
							</div>
							<div style={{background:'#ffffff'}}>
								<Window width={53} name={'contact-me.txt'} logo={""} links={socialLinks} body={""} projects={""}></Window>
							</div>
						</Box>
						<Box display='flex' justifyContent={'center'} style={{fontFamily:'monospace'}}> Copyright © Madeline Hatfield 2024</Box>
					</Box>
				</div>
			</div>
		</>
	);
}

export default App;
